<i *ngIf="!withText" class="fa fa-video-camera" [ngClass]="{'marginLeft': marginLeft, 'marginRight': marginRight}" (click)="open()"></i>
<div *ngIf="withText" class="" fxLayout="row" fxLayoutAlign=" center" [ngClass]="{'marginLeft': marginLeft, 'marginRight': marginRight}" (click)="open()">
  <span>{{languages}}</span>
  <i class="fa fa-video-camera marginLeft"></i>
</div>
